module.exports = "<i class={{icon}} *ngIf=icon></i> <div class=tile-title>{{ tileTitle }}</div> <div class=tile-data> <ng-content></ng-content> </div> ";